export default "__VITE_ASSET__BuhPlCCR__"